import { useState, useCallback } from "react";

import { CREATININE_UNITS } from "../../utils/calculators/constants";

// Provides consistent serum creatinine input state and handlers across all calculators
export const useSerumCreatinineInput = (defaultUnit = "micromoles/L") => {
  const [creatinineValue, setCreatinineValue] = useState("");
  const [creatinineUnit, setCreatinineUnit] = useState(defaultUnit);

  const clearCreatinineError = useCallback((setErrors) => {
    if (setErrors) {
      setErrors((prev) => ({ ...prev, serumCreatinine: "" }));
    }
  }, []);

  const handleCreatinineChange = useCallback((e, setErrors) => {
    const newValue = e.target.value.replace(/^0+/, "");
    setCreatinineValue(newValue);
    clearCreatinineError(setErrors);
  }, [clearCreatinineError]);

  const handleCreatinineUnitChange = useCallback((e, setErrors) => {
    const newUnit = e.target.value;
    if (newUnit !== creatinineUnit) {      
      setCreatinineValue("");
    }
    setCreatinineUnit(newUnit);
    clearCreatinineError(setErrors);
  }, [creatinineUnit, clearCreatinineError]);

  const clearCreatinineFields = useCallback(() => {
    setCreatinineValue("");
    setCreatinineUnit(defaultUnit);
  }, [defaultUnit]);

  return {    
    creatinineValue,
    creatinineUnit,
    serumCreatinineValue: creatinineValue,
    serumCreatinineUnit: creatinineUnit,    
   
    handleCreatinineChange,
    handleCreatinineUnitChange,
    handleSerumCreatinineChange: handleCreatinineChange,
    handleSerumCreatinineUnitChange: handleCreatinineUnitChange,
    clearCreatinineFields,
    clearSerumCreatinineFields: clearCreatinineFields,    
    
    setCreatinineValue,
    setCreatinineUnit,  
   
    unitOptions: CREATININE_UNITS,
  };
};

export default useSerumCreatinineInput;
